export var MPointStationType;
(function (MPointStationType) {
    MPointStationType[MPointStationType["PrimaryPoint"] = 3] = "PrimaryPoint";
    MPointStationType[MPointStationType["DeliveryPoint"] = 10] = "DeliveryPoint";
    MPointStationType[MPointStationType["SecondaryPoint"] = 5] = "SecondaryPoint";
    MPointStationType[MPointStationType["SwitchingPoint"] = 6] = "SwitchingPoint";
    MPointStationType[MPointStationType["Undefined"] = 999] = "Undefined";
})(MPointStationType || (MPointStationType = {}));
